<template>
    <v-card elevation="0" class="scroll" :height="winsize.height - 145">
        <v-card-actions class="ma-0 pa-0">
            <v-card elevation="1" outlined width="100%" :height="winsize.height - 145">
                <v-card-actions class="ma-0 pa-0">
                    <div>
                        <v-card outlined height="100px" width="200px" v-for="(item, value) in items" :key="item" :style="{'position': 'absolute', 'margin-left': '5px','margin-top':(110 * value + 5) + 'px'}">
                            <v-movable>
                                <v-card width="192" height="30" elevation="0" outlined class="ma-1">
                                    <v-card-actions>{{item}}</v-card-actions>
                                </v-card>
                            </v-movable>
                        </v-card>
                    </div>
<!--                    <div style="position:relative; margin:10px; border: red solid 1px; height: 900px">-->

<!--                        <v-movable class="testmove" posTop="110" :grid="20" style="border: #252932 solid 1px">-->
<!--                            <v-card width="50px" height="50px" color="red" elevation="0"></v-card>-->
<!--                        </v-movable>-->
<!--                        <v-movable class="testmove" posTop="220" posLeft="0" shiftKey="true">-->
<!--                            <v-card width="50px" height="50px" color="green" elevation="0"></v-card>-->
<!--                        </v-movable>-->
<!--                        <v-movable class="testmove" posTop="330" posLeft="0" :bounds="{x:[0,0]}">-->
<!--                            <v-card width="50px" height="50px" color="pink" elevation="0"></v-card>-->
<!--                        </v-movable>-->
<!--                        <v-movable class="testmove" posTop="440" posLeft="0" :bounds="{y:[0,0]}">-->
<!--                            <v-card width="50px" height="50px" color="black" elevation="0"></v-card>-->
<!--                        </v-movable>-->
<!--                    </div>-->
                </v-card-actions>
            </v-card>
        </v-card-actions>
    </v-card>
</template>

<script>


import VMovable from "@/modules/muiutils/views/movable/v-movable";
import configJson from '@/modules/muiutils/resources/config.json';

export default {
    name: "utils-test-page",
    components: {VMovable},
    computed:{
        winsize() {
            return window.app.winsize;
        },
        items(){
            var final = []
            for (const [key, value] of Object.entries(configJson)) {
                //console.log(`${key}: ${value}`);
                final.push(key)
            }
            console.log(final);
            return final
        }
    },
    mounted() {

    },
    methods: {

    }
}
</script>

<style scoped>
.scroll {
    overflow-y: scroll
}
.testmove {
    display:block;
    position: absolute;
    height: 100px;
    width: 200px;
    cursor: pointer;
}
.modaltitle {
    background: blue;
    display:block;
    width:100%;
    color: white;
    cursor: pointer;
}
</style>